import React, { useEffect, useState } from 'react';
import './SectorPieChart.css';

const COLORS = [
  '#4e79a7', '#f28e2b', '#e15759', '#76b7b2', '#59a14f', '#edc948',
  '#b07aa1', '#ff9da7', '#9c755f', '#bab0ab', '#86bc86', '#d37295'
];

const SectorPieChart = () => {
  const [sectorData, setSectorData] = useState([]);

  useEffect(() => {
    fetch('/api/sector_breakdown')
      .then(res => res.json())
      .then(data => {
        const colored = data.map((d, i) => ({ ...d, color: COLORS[i % COLORS.length] }));
        setSectorData(colored);
      })
      .catch(() => setSectorData([]));
  }, []);

  const radius = 110; // radius of the pie in px
  let cumulative = 0;

  const paths = sectorData.map(d => {
    const startAngle = (cumulative / 100) * 2 * Math.PI;
    const endAngle = ((cumulative + d.percentage) / 100) * 2 * Math.PI;
    const largeArc = d.percentage > 50 ? 1 : 0;
    const x1 = radius + radius * Math.sin(startAngle);
    const y1 = radius - radius * Math.cos(startAngle);
    const x2 = radius + radius * Math.sin(endAngle);
    const y2 = radius - radius * Math.cos(endAngle);
    const path = `M ${radius} ${radius} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z`;
    const midAngle = (startAngle + endAngle) / 2;
    const labelRadius = radius * 0.6;
    const labelX = radius + labelRadius * Math.sin(midAngle);
    const labelY = radius - labelRadius * Math.cos(midAngle);
    cumulative += d.percentage;
    return { path, color: d.color, labelX, labelY, count: d.count, percentage: d.percentage };
  });

  if (!sectorData.length) return null;

  return (
    <div className="sector-pie-chart">
      <h3 className="chart-title">STOXX Europe 600: Composition by Sector</h3>
      <div className="chart-content">
        <svg
          className="pie-svg"
          width={radius * 2}
          height={radius * 2}
          viewBox={`0 0 ${radius * 2} ${radius * 2}`}
        >
          {paths.map((d, i) => (
            <g key={i}>
              <path d={d.path} fill={d.color} stroke="#fff" strokeWidth="2" />
              <text
                x={d.labelX}
                y={d.labelY}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="12"
                fill="#ffffff"
              >
                {d.count}
              </text>
            </g>
          ))}
        </svg>
        <ul className="legend">
          {sectorData.map(d => (
            <li key={d.sector}>
              <span className="color" style={{ background: d.color }} />
              {d.sector} {d.percentage}%
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SectorPieChart;
